import React from 'react';
import insertRule, { getStyleBucketName, styleBucketOrdering } from './sheet';
import { analyzeCssInDev } from './dev-warnings';
import { useCache } from './style-cache';
import { isNodeEnvironment } from './is-node';
export default function Style(props) {
    var inserted = useCache();
    if (process.env.NODE_ENV === 'development') {
        props.children.forEach(analyzeCssInDev);
    }
    if (props.children.length) {
        if (isNodeEnvironment()) {
            var bucketedSheets_1 = {};
            var hasSheets = false;
            for (var i = 0; i < props.children.length; i++) {
                var sheet = props.children[i];
                if (inserted[sheet]) {
                    continue;
                }
                else {
                    inserted[sheet] = true;
                    hasSheets = true;
                }
                var bucketName = getStyleBucketName(sheet);
                bucketedSheets_1[bucketName] = (bucketedSheets_1[bucketName] || '') + sheet;
            }
            if (!hasSheets) {
                return null;
            }
            return (React.createElement("style", { "data-cmpld": true, nonce: props.nonce, dangerouslySetInnerHTML: {
                    __html: styleBucketOrdering.map(function (bucket) { return bucketedSheets_1[bucket]; }).join(''),
                } }));
        }
        else {
            for (var i = 0; i < props.children.length; i++) {
                var sheet = props.children[i];
                if (inserted[sheet]) {
                    continue;
                }
                inserted[sheet] = true;
                insertRule(sheet, props);
            }
        }
    }
    return null;
}
//# sourceMappingURL=style.js.map